import authInstance from "../utilities/axios/authInstance";

export const allSchedules = () => authInstance.get('schedules');

export const oneSchedule = (id) => authInstance.get('schedules/' + id);

export const addSchedule = (schedule) => authInstance.post('schedules',schedule);

export const updateSchedule = (id, schedule) => authInstance.put('schedules/' + id, schedule);

export const removeSchedule = (id) => authInstance.delete('schedules/' + id);